import React from 'react';

function SharedHeader({
  title,
  searchQuery,
  onSearchChange,
  searchPlaceholder = 'Search',
  resultCount,
  resultLabel = 'Results',
  onSortClick,
  onFilterClick,
  filterLabel = 'Filter',
  sortActive = false,
  filterActive = false,
  isSortApplied = false,
  isFilterApplied = false,
  onExportClick,
  onAddNewClick,
  addNewText = 'Add New',
  addNewDisabled = false,
  exportDisabled = false,
  showSortFilter = true,
  canAddNew = true,
  canExport = true
}) {
  return (
    <div className="song-header-section">
      <div className="song-header-top">
        <h1 className="song-title">{title}</h1>
      </div>
      
      <div className="song-controls-row">
        <div className="controls-left">
          {showSortFilter && (
            <>
              {/* Sort By Button */}
              <button
                type="button"
                className={`action-btn-outlined ${sortActive ? 'active' : ''} ${isSortApplied ? 'applied' : ''}`}
                onClick={onSortClick}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="4" y1="6" x2="16" y2="6" />
                  <line x1="4" y1="12" x2="11" y2="12" />
                  <line x1="4" y1="18" x2="7" y2="18" />
                </svg>
                <span>Sort By</span>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ marginLeft: '4px' }}>
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>
              
              {/* Filter Button */}
              <button
                type="button"
                className={`action-btn-outlined ${filterActive ? 'active' : ''} ${isFilterApplied ? 'applied' : ''}`}
                onClick={onFilterClick}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                </svg>
                <span>{filterLabel}</span>
              </button>
            </>
          )}
          
          {/* Result Count Label */}
          {resultCount !== undefined && resultCount !== null && (
            <span className="results-label">
              {resultCount} {resultLabel}
            </span>
          )}
        </div>
        
        {/* Search Input Container */}
        <div className="search-bar-container">
          <div className="search-icon-wrapper">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </div>
          <input
            type="text"
            className="search-input"
            placeholder={searchPlaceholder}
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          {searchQuery && (
            <button 
              type="button" 
              className="search-clear-btn" 
              onClick={() => onSearchChange('')} 
              aria-label="Clear Search"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          )}
          <button type="button" className="search-settings-btn" aria-label="Search Settings">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="3" />
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" fill="none" />
            </svg>
          </button>
        </div>

        <div className="controls-right">
          {/* Export Button */}
          {onExportClick && canExport && (
            <button
              type="button"
              className="action-btn-outlined"
              onClick={onExportClick}
              disabled={exportDisabled}
              style={{
                opacity: exportDisabled ? 0.5 : 1,
                cursor: exportDisabled ? 'not-allowed' : 'pointer'
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="17 8 12 3 7 8" />
                <line x1="12" y1="3" x2="12" y2="15" />
              </svg>
              <span>Export</span>
            </button>
          )}
          
          {/* Add New Button */}
          {onAddNewClick && canAddNew && (
            <button
              type="button"
              className="action-btn-primary"
              onClick={onAddNewClick}
              disabled={addNewDisabled}
              style={{
                opacity: addNewDisabled ? 0.5 : 1,
                cursor: addNewDisabled ? 'not-allowed' : 'pointer'
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
              <span>{addNewText}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default SharedHeader;
